<template>
  <v-container fluid id="rentals">
    <v-row wrap justify="center">
      <v-col xs="12" class="headline pb-0">Tool Rentals</v-col>
      <!--  TRUCK REQUESTS -->
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-data-table
            :items="toolRentals"
            :headers="headers"
            :footer-props="{
              'items-per-page-options': [30, 40, 50],
            }"
            :items-per-page="30"
            sort-by="orderDate"
            sort-desc
            loading-text="Loading tool rental list..."
            loading="!toolRentals.length"
            item-key=""
          >
            <template v-slot:item.image="{ item }">
              <div class="py-2">
                <v-img :src="item.image" width="60" height="60" contain />
              </div>
            </template>
            <template v-slot:item.rentalDate="{ item }">
              <span v-if="item.rentalDate">
                {{ item.rentalDate.toDate() | moment("MMM Do YYYY") }}
              </span>
            </template>
            <template v-slot:item.jobSite="{ item }">
              {{ item.jobSite.street }}<br />
              <span class="caption">
                {{ item.jobSite.department.join() }} (<strong>{{
                  item.jobSite.jobId
                }}</strong
                >)
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
export default {
  data() {
    return {
      toolRentals: [],
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "image",
          width: 80,
        },
        { text: "Name", value: "title" },
        { text: "Rental Date", value: "rentalDate" },
        { text: "Job Site", value: "jobSite" },
      ],
    };
  },
  computed: {},
  async created() {
    const resCacheJobs = await fb.db.collection("cacheJobs").get();
    const toolRentals = [];
    resCacheJobs.forEach((j) => {
      const jobData = j.data();
      if (jobData.rentals && jobData.rentals.length) {
        const rentals = jobData.rentals.map((r) => {
          return { ...r, ...jobData };
        });
        toolRentals.push(rentals);
      }
    });
    this.toolRentals = toolRentals.flat();
  },
  methods: {},
};
</script>
